import {
  Link,
} from 'tiptap-extensions';

import VisitLink from './VisitLink.vue';

export default class TargetBlankLink extends Link {
  get schema() {
    return {
      attrs: {
        href: {
          default: null,
        },
        target: {
          default: null,
        },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: (dom) => ({
            href: dom.getAttribute('href'),
            target: dom.getAttribute('target'),
          }),
        },
      ],
      toDOM: (node) => ['a', {
        ...node.attrs,
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
      }, 0],
    };
  }

  get view() {
    return VisitLink;
  }
}
